import React from "react";
import { AppLayout } from "@/components/ui/app-layout";
import { EnhancedHeader } from "@/components/ui/enhanced-header";
import { Trophy, Gift, ShoppingBag } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { DailyReward } from "@/components/currency/DailyReward";
import { DailyRewardStreak } from "@/components/currency/DailyRewardStreak";
import { GameVictoryRewards, AchievementRewards } from "@/components/currency/Rewards";
import { CurrencyDisplay } from "@/components/currency/CurrencyDisplay";

export default function RewardsPage() {
  return (
    <AppLayout>
      <EnhancedHeader
        title="Game Rewards"
        backPath="/games"
        coloredText={true}
        rightContent={
          <div className="flex items-center gap-2">
            <CurrencyDisplay variant="icon" size="sm" />
            <DailyReward />

          </div>
        }
        showScrollEffect={true}
      />

      <div className="py-2 px-4 sm:px-6 lg:px-8">
        <div className="space-y-6">
          <Tabs defaultValue="daily">
            <TabsList className="grid w-full grid-cols-3">
              <TabsTrigger value="daily" className="flex items-center gap-1">
                <Gift className="h-4 w-4" />
                <span className="hidden sm:inline">Daily Login</span>
              </TabsTrigger>
              <TabsTrigger value="games" className="flex items-center gap-1">
                <ShoppingBag className="h-4 w-4" />
                <span className="hidden sm:inline">Game Victories</span>
              </TabsTrigger>
              <TabsTrigger value="achievements" className="flex items-center gap-1">
                <Trophy className="h-4 w-4" />
                <span className="hidden sm:inline">Achievements</span>
              </TabsTrigger>
            </TabsList>

            <TabsContent value="daily" className="py-4">
              <div className="bg-gray-900 border border-gray-700 rounded-lg shadow-sm p-6">
                <h3 className="text-lg font-medium mb-2 text-white">
                  Daily Login Rewards
                </h3>
                <p className="text-sm text-gray-400 mb-4">
                  Log in every day to earn coins and premium rewards. Don't
                  miss a day for maximum rewards!
                </p>
                <DailyRewardStreak />
              </div>
            </TabsContent>

            <TabsContent value="games" className="py-4">
              <div className="space-y-4">
                <h3 className="text-lg font-medium text-white">
                  Game Victory Rewards
                </h3>
                <p className="text-sm text-gray-400 mb-4">
                  Win games to earn rewards. Challenge more players to earn
                  more!
                </p>
                <GameVictoryRewards limit={5} />
              </div>
            </TabsContent>

            <TabsContent value="achievements" className="py-4">
              <div className="space-y-4">
                <h3 className="text-lg font-medium text-white">
                  Achievement Rewards
                </h3>
                <p className="text-sm text-gray-400 mb-4">
                  Complete achievements to earn currency rewards. Harder
                  achievements give better rewards!
                </p>
                <AchievementRewards limit={5} />
              </div>
            </TabsContent>
          </Tabs>
        </div>
      </div>
    </AppLayout>
  );
}